import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "blog-list-area ptb-100" }
const _hoisted_2 = { class: "container mw-1356" }
const _hoisted_3 = {
  key: 0,
  class: "text-center text-silver py-5"
}
const _hoisted_4 = {
  key: 1,
  class: "text-center text-silver py-5"
}
const _hoisted_5 = {
  key: 2,
  class: "row g-4"
}
const _hoisted_6 = { class: "blog-card-img" }
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = {
  key: 1,
  class: "blog-card-img-placeholder"
}
const _hoisted_9 = { class: "blog-card-body" }
const _hoisted_10 = { class: "blog-card-date" }
const _hoisted_11 = { class: "blog-card-title" }
const _hoisted_12 = { class: "blog-card-excerpt" }
const _hoisted_13 = {
  key: 3,
  class: "blog-pagination mt-60"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "text-silver px-3" }
const _hoisted_16 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavbarTwo = _resolveComponent("NavbarTwo")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_MainFooter = _resolveComponent("MainFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavbarTwo),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "section-title text-center mb-60",
          "data-aos": "fade-up",
          "data-aos-duration": "1000"
        }, [
          _createElementVNode("span", { class: "top-title" }, "OUR BLOG"),
          _createElementVNode("h2", { class: "text-white" }, "Latest News & Guides"),
          _createElementVNode("p", { class: "text-silver" }, "Tips, guides, and streaming news to get the most out of your IPTV.")
        ], -1)),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Loading posts..."))
          : (_ctx.posts.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " No posts published yet. Check back soon. "))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: post.id,
                    class: "col-md-6 col-lg-4",
                    "data-aos": "fade-up",
                    "data-aos-duration": "1000"
                  }, [
                    _createVNode(_component_RouterLink, {
                      to: '/blog/' + post.slug,
                      class: "blog-card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          (post.cover_image)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: post.cover_image,
                                alt: post.title
                              }, null, 8, _hoisted_7))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "ti ti-article" }, null, -1)
                              ])))
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.formatDate(post.published_at)), 1),
                          _createElementVNode("h3", _hoisted_11, _toDisplayString(post.title), 1),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(post.excerpt), 1),
                          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "blog-card-link" }, [
                            _createTextVNode("Read More "),
                            _createElementVNode("i", { class: "ti ti-arrow-right" })
                          ], -1))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ])),
        (_ctx.totalPages > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("button", {
                class: "btn",
                disabled: _ctx.page === 1,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadPage(_ctx.page - 1)))
              }, _cache[4] || (_cache[4] = [
                _createElementVNode("span", { class: "border-style" }, [
                  _createElementVNode("i", { class: "ti ti-chevron-left" }),
                  _createTextVNode(" Prev")
                ], -1)
              ]), 8, _hoisted_14),
              _createElementVNode("span", _hoisted_15, "Page " + _toDisplayString(_ctx.page) + " of " + _toDisplayString(_ctx.totalPages), 1),
              _createElementVNode("button", {
                class: "btn",
                disabled: _ctx.page === _ctx.totalPages,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadPage(_ctx.page + 1)))
              }, _cache[5] || (_cache[5] = [
                _createElementVNode("span", { class: "border-style" }, [
                  _createTextVNode("Next "),
                  _createElementVNode("i", { class: "ti ti-chevron-right" })
                ], -1)
              ]), 8, _hoisted_16)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_MainFooter)
  ]))
}